// ** React Imports
import { useEffect } from 'react';

// ** Next Imports
import { useRouter } from 'next/router';

// ** Hook Imports
import { useAuth } from 'react-oidc-context';

// ** MUI License management
import { LicenseInfo } from '@mui/x-license-pro';

import VigoSpinner from 'src/@vigo/vigo-spinner';

/**
 *  Set Home URL based on User Roles *** FIX THIS ***
 */
export const getHomeRoute = (role: string) => {
  if (role === 'client') return '/acl';
  else return '/dashboards/Home';
};

const Home = () => {
  // license the MUI controls
  LicenseInfo.setLicenseKey(
    '9c0ebfdf99bcad1fabe46ea4a7dc3d67Tz0xMTc0MjgsRT0xNzg2MjMzNTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
  );

  // ** Hooks
  const auth = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    sessionStorage.removeItem('app_redirect');
    if (auth.user) {
      const homeRoute = getHomeRoute('admin');
      router.replace(homeRoute);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <VigoSpinner name="homeSpinner" />;
};

export default Home;
